import type React from "react";
import { useTranslation } from "react-i18next";
import type { ValidationError } from "../types/isdoc";

interface ValidationErrorsProps {
  errors: ValidationError[];
}

export const ValidationErrors: React.FC<ValidationErrorsProps> = ({
  errors,
}) => {
  const { t } = useTranslation();

  if (errors.length === 0) return null;

  const errorCount = errors.filter((e) => e.type === "error").length;
  const warningCount = errors.filter((e) => e.type === "warning").length;

  return (
    <div className="mb-6 no-print">
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg
              className="h-5 w-5 text-yellow-400"
              viewBox="0 0 20 20"
              fill="currentColor"
              role="img"
              aria-label="Warning icon"
            >
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">
              {t("validation.title", {
                errors: errorCount,
                warnings: warningCount,
              })}
            </h3>
            <div className="mt-2 text-sm text-yellow-700">
              <ul className="list-disc list-inside space-y-1">
                {errors.map((error, index) => (
                  <li
                    key={`${error.type}-${error.location || index}-${error.messageKey}`}
                    className={error.type === "error" ? "font-semibold" : ""}
                  >
                    {t(error.messageKey, error.messageParams)}
                    {error.location && (
                      <span className="text-yellow-600 text-xs ml-2">
                        ({error.location})
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
